import { useQuery } from '@tanstack/react-query';
import { conflictService } from '../services/conflictService';
import type { Conflict } from '../types/conflict';
import type { PaginationParams, PaginatedResponse } from '../types/pagination';
import { PAGINATION_DEFAULTS } from '../types/pagination';

type UseConflictsOptions = PaginationParams;

interface UseConflictsResult {
  data: Conflict[];
  total: number;
  page: number;
  limit: number;
  isLoading: boolean;
  error: Error | null;
}

export const useConflicts = (options?: UseConflictsOptions): UseConflictsResult => {
  const page = options?.page ?? PAGINATION_DEFAULTS.page;
  const limit = options?.limit ?? PAGINATION_DEFAULTS.limit;

  const query = useQuery<PaginatedResponse<Conflict>>({
    queryKey: ['conflicts', { page, limit }],
    queryFn: () => conflictService.getConflicts({ page, limit }),
  });

  return {
    data: query.data?.data ?? [],
    total: query.data?.total ?? 0,
    page: query.data?.page ?? page,
    limit: query.data?.limit ?? limit,
    isLoading: query.isLoading,
    error: query.error,
  };
};
